import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import UserPage from 'flarum/forum/components/UserPage';
import PostUser from 'flarum/forum/components/PostUser';
import LinkButton from 'flarum/common/components/LinkButton';
import Link from 'flarum/common/components/Link';
const t = (k, p) => app.translator.trans('ernestdefoe-projects.forum.' + k, p);
app.initializers.add('ernestdefoe/projects', () => {
  // The pages are chunks fetched when first visited, not part of every page.
  app.routes['projects'] = {
    path: '/projects',
    component: () => import(/* webpackChunkName: 'forum/components/ProjectsPage', webpackMode: 'lazy-once' */ './components/ProjectsPage')
  };
  app.routes['projects.show'] = {
    path: '/projects/p/:slug',
    component: () => import(/* webpackChunkName: 'forum/components/ProjectPage', webpackMode: 'lazy-once' */ './components/ProjectPage')
  };
  app.routes['user.projects'] = {
    path: '/u/:username/projects',
    component: () => import(/* webpackChunkName: 'forum/components/UserProjectsPage', webpackMode: 'lazy-once' */ './components/UserProjectsPage')
  };

  // Sidebar nav link (sits with "All Discussions").
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    items.add('projects', LinkButton.component({
      href: app.route('projects'),
      icon: 'fas fa-cubes'
    }, t('nav')), 5);
  });

  // "Projects" tab on member profiles.
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    if (!user) return;
    items.add('projects', LinkButton.component({
      href: app.route('user.projects', {
        username: user.username()
      }),
      icon: 'fas fa-cubes'
    }, t('profile.tab')), 80);
  });

  // Featured-project badge next to the username. It sits beside FoF Badges'
  // primary badge but uses its OWN standalone class (NOT `.PrimaryBadge`) so
  // fof/badges' circular-badge styling can't bleed in and clash — the two
  // badges are visually independent. Reads the denormalised `projectFeatured`
  // snapshot (no per-render query) and links to the project.
  extend(PostUser.prototype, 'view', function (vnode) {
    const post = this.attrs.post;
    const user = post && typeof post.user === 'function' ? post.user() : null;
    const featured = user && typeof user.attribute === 'function' ? user.attribute('projectFeatured') : null;
    if (!featured || !featured.title || !featured.slug) return;
    if (!vnode || !Array.isArray(vnode.children)) return;
    vnode.children.push(m(Link, {
      href: app.route('projects.show', {
        slug: featured.slug
      }),
      className: 'ProjectFeaturedBadge',
      title: featured.title,
      style: featured.color ? {
        '--project-accent': featured.color
      } : undefined,
      onclick: e => e.stopPropagation()
    }, [m('i', {
      className: featured.icon || 'fas fa-cube'
    }), m('span.ProjectFeaturedBadge-name', featured.title)]));
  });
});flarum.reg.addChunkModule('ernestdefoe-projects:forum/components/ProjectsPage', '973', 'ernestdefoe-projects', 'forum/components/ProjectsPage');
flarum.reg.addChunkModule('ernestdefoe-projects:forum/components/ProjectPage', '202', 'ernestdefoe-projects', 'forum/components/ProjectPage');
flarum.reg.addChunkModule('ernestdefoe-projects:forum/components/UserProjectsPage', '932', 'ernestdefoe-projects', 'forum/components/UserProjectsPage');
flarum.reg.addChunkModule('ernestdefoe-projects:forum/components/ProjectsPage', '973', 'ernestdefoe-projects', 'common/api');
flarum.reg.addChunkModule('ernestdefoe-projects:forum/components/ProjectsPage', '973', 'ernestdefoe-projects', 'forum/authorAvatar');
flarum.reg.addChunkModule('ernestdefoe-projects:forum/components/ProjectsPage', '973', 'ernestdefoe-projects', 'forum/components/ProjectCard');
flarum.reg.addChunkModule('ernestdefoe-projects:forum/components/ProjectsPage', '973', 'ernestdefoe-projects', 'forum/components/ProjectsSkeleton');
flarum.reg.addChunkModule('ernestdefoe-projects:forum/components/ProjectsPage', '973', 'ernestdefoe-projects', 'forum/components/StyledSelect');
flarum.reg.addChunkModule('ernestdefoe-projects:forum/components/ProjectsPage', '973', 'ernestdefoe-projects', 'forum/openProjectForm');